import { prog } from '../../../../motion'
import { Fit, Line } from '../../../../v2/kit'
import { DEMO_CASES } from '../../../demo/copy'
import { useCopy } from '../../../i18n'
import { MaskText } from '../../stage/fx'
import { useBranch } from '../branch'

export const CASES_PARTICLES = [
  [0.04, () => ({ type: 'scatter', alpha: 0.16, seed: 43 })],
  [0.96, () => ({ type: 'scatter', alpha: 0.16, seed: 47 })]
]

const N = DEMO_CASES.length
const STEP = 360 / N
const CARD_W = 420
// Radius so, dass die Karten mit etwas Luft im Kreis stehen
const RADIUS = Math.round((CARD_W / (2 * Math.tan(Math.PI / N))) * 1.12)
const NARROW = { maxW: 0.92, maxH: 0.6 }

// Ein Karussell im Raum dreht sich mit dem Scroll. Die Fallstudie der gewählten Branche steht vorn
export default function DmsCases() {
  const c = useCopy('faelle')
  const s = useCopy('show')
  const b = useCopy('branches')
  const branch = useBranch()
  const ordered = branch.lead
    ? [
        ...DEMO_CASES.filter((k) => k.id === branch.lead),
        ...DEMO_CASES.filter((k) => k.id !== branch.lead)
      ]
    : DEMO_CASES

  return (
    <div className='sc-full'>
      <div className='dms-cases-head'>
        <Line at={[0, 0.05]} className='sc-eyebrow'>
          {c.eyebrow}
        </Line>
        <h2 className='sc-h2'>
          <MaskText text={c.title} at={[0.02, 0.12]} />
        </h2>
        {branch.id !== 'allgemein' && (
          <span className='sc-chip dms-cases-branch'>
            {b.label}: {b.names[branch.id]}
          </span>
        )}
      </div>

      <Fit
        w={560}
        h={560}
        maxW={0.96}
        maxH={0.64}
        narrow={NARROW}
        className='dms-carousel-fit'
      >
        <div className='dms-carousel' style={prog([0.1, 0.94])} key={branch.id}>
          <div
            className='dms-carousel__spin'
            style={{
              '--n': N,
              '--step': `${STEP}deg`,
              transform: `translateZ(${-RADIUS}px) rotateY(calc(var(--p) * ${-(N - 1) * STEP}deg))`
            }}
          >
            {ordered.map((k, i) => {
              const story = c.cases[k.id]
              return (
                <article
                  key={k.id}
                  className={
                    k.id === branch.lead ? 'dms-case is-lead' : 'dms-case'
                  }
                  style={{
                    '--i': i,
                    transform: `rotateY(${i * STEP}deg) translateZ(${RADIUS}px)`
                  }}
                >
                  <div className='dms-case__top'>
                    <img
                      src={k.logo}
                      alt={story.name}
                      className='dms-case__logo'
                    />
                    <span className='dms-case__branch'>{story.branch}</span>
                  </div>
                  <div className='sc-num dms-case__value sc-grad'>
                    {story.value}
                  </div>
                  <div className='dms-case__label'>{story.valueLabel}</div>
                  <blockquote className='dms-case__quote'>
                    {story.quote}
                  </blockquote>
                  <div className='dms-case__author'>{story.author}</div>
                </article>
              )
            })}
          </div>
        </div>
      </Fit>

      <div className='dms-cases-hint'>{s.casesHint}</div>
    </div>
  )
}
